export function addLeadingZero(n: number): string {
  let text = '' + n;
  if (text.length === 1) {
    text = '0' + text;
  }
  return text;
}
